// Copyright 2026, University of Maryland, All Rights Reserved
import { type FC } from 'react'

import type { RendererComponentProps } from '@/app-shell/renderer-components'
import { ContractAnalysisLayout } from '../components/ContractAnalysisLayout'
import { extractHeadline, extractSummary, extractFindings, extractScore } from '../hooks/extractors'

export const ContractAnalysisRenderer: FC<RendererComponentProps> = ({
  renderer,
  documentId,
  documentName,
  orgId,
  workspaceId,
  agentId,
  version,
  slotData = {},
}) => {
  const summaryRes = slotData.summary ?? null
  const findingsRes = slotData.findings ?? null

  const findings = extractFindings(findingsRes)

  const findingsSlot = renderer.slots.find(s => s.key === 'findings' && s.type === 'dataset')
  const datasetKey = findingsSlot?.datasetKey ?? undefined

  return (
    <ContractAnalysisLayout
      headline={extractHeadline(summaryRes)}
      summary={extractSummary(summaryRes)}
      score={extractScore(findingsRes)}
      findings={findings}
      documentId={documentId}
      orgId={orgId}
      workspaceId={workspaceId}
      agentId={agentId}
      datasetKey={datasetKey}
      version={version}
      run={findingsRes?.run}
      documentName={documentName}
    />
  )
}
